// Espelha o contrato do backend Go (pesquisa_handler / pesquisaService).
// Tabela de pesquisa genérica (APL_PESQUISA): cabeçalho + perguntas + alternativas.
// Endpoints de objeto único (sem ApiResponse), seguindo o padrão de detalhe.

// Ação registrada na última interação do usuário com a pesquisa:
// 'R' = respondido (enviou as respostas) | 'A' = adiado (clicou em "Agora não").
export type PesquisaTpAcao = 'R' | 'A';

export interface Pesquisa {
  cd_pesquisa: number;
  nm_pesquisa: string;
  ds_descricao: string;
  nr_intervalo_dias: number;
  nr_intervalo_recusa_hrs: number;
  ib_ativa: number;
  dt_ultima_resposta: string | null;
  tp_ultima_acao: PesquisaTpAcao | null;
  perguntas: PesquisaItemPergunta[];
}

export interface PesquisaItemPergunta {
  cd_item_pergunta: number;
  ds_pergunta: string;
  nr_ordem: number;
  alternativas: PesquisaItemAlternativa[];
}

export interface PesquisaItemAlternativa {
  cd_item_alternativa: number;
  ds_alternativa: string;
  nr_ordem: number;
  ib_ativa: number;
}

// Corpo do POST de resposta. tp_acao indica se é um envio ('R') ou um adiamento ('A').
// As respostas só são obrigatórias quando tp_acao === 'R'; no adiamento vão vazias.
// cd_item_alternativa é usado em perguntas de múltipla escolha; vl_resposta guarda
// escala (ex.: nota "9" do NPS) ou texto livre.
export interface PesquisaRespostaRequest {
  tp_acao: PesquisaTpAcao;
  respostas?: PesquisaItemResposta[];
}

export interface PesquisaItemResposta {
  cd_item_pergunta: number;
  cd_item_alternativa?: number | null;
  vl_resposta?: string | null;
}

// Retorno do POST (HTTP 201).
export interface PesquisaRespostaResponse {
  cd_resposta: number;
}
